/**
 * 移动端返回上一页函数
 * 
 * 调用客户端原生的返回功能，在不同环境中自动适配：
 * - 在同花顺/iFind/期货客户端中，调用原生返回方法
 * - 在其他环境中，使用 history.back()
 * 
 * @returns void
 */
import { isInThsApp } from '../../base/env/app/isInThsApp';
import { isInIFindApp } from '../../base/env/app/isInIFindApp';
import { isInFuturesApp } from '../../base/env/app/isInFuturesApp';
import { getPlatform } from '../../base/env/platform/getPlatform';

/**
 * 移动端返回上一页
 */
export function goBack(type?: 'webview' | 'webpage'): void {
  if (isInThsApp() || isInIFindApp() || isInFuturesApp()) {
    const defaultType = getPlatform() === 'iphone' ? 'webview' : 'webpage';
    const finalType = type ?? defaultType;

    if (typeof window.callNativeHandler === 'function') {
      window.callNativeHandler('goback', { type: finalType }, () => {});
    } else {
      window.history.back();
    }
  } else {
    window.history.back();
  }
} 